import React from "react";

const PleaseLogin = () => {
    return (
        <div className='contentContainer'>
            <br />
            <p>Um fortzufahren, melden Sie sich bitte an. </p>
        </div>
    )
}

export default PleaseLogin;